export const REACT_PRIVATE_PROPS = [ "children", "hooks", "ref" ];
//# sourceMappingURL=constants.js.map
